import * as api from '@/api'

const search = {
  namespaced: true,
  state: {
    suggests: [],
    searchKeyword: '',
    showSearchResult: false, // 検索結果を見せるか(商品詳細から戻ってきたときに検索結果を表示する用)
    tagName: '', // 直近に検索した検索タグ
  },
  getters: {
    /**
     * キーワードを含むサジェストの配列を返す
     */
    getSuggestsByKeyword: (state) => (keyword) => {
      if (!keyword) return []
      return state.suggests.filter(
        (suggest) => Object.keys(suggest)[0].toLowerCase().indexOf(keyword) > -1
      )
    },
    /**
     * 一致するサジェストの配列を返す
     */
    getSuggestsByTagName: (state) => (tagName) => {
      if (!tagName) return []
      return state.suggests.filter((suggest) => suggest[tagName])
    },
    /**
     * タグ名に対応する商品コード(配列)を返す
     */
    getItemCodesByTagName: (_state_, getters) => (tagName) => {
      const suggests = getters.getSuggestsByTagName(tagName)
      const codes = suggests.flatMap((item) => item[tagName])
      // 配列をユニークに変換
      return Array.from(new Set(codes))
    },
    /**
     * 検索語句を取得する
     */
    getSearchKeyword: (state) => {
      return state.searchKeyword
    },
    getSuggests: (state) => {
      return state.suggests
    },
    isShowSearchResult: (state) => {
      return state.showSearchResult
    },
    getTagName: (state) => {
      return state.tagName
    },
  },
  actions: {
    /**
     * APIから広告タグと商品コードの配列を取得する
     */
    fetchSuggests: ({ commit, rootGetters }) => {
      const shopId = rootGetters['seat/getShopId']
      api.fetchSuggests(shopId).then((res) => {
        commit('setSuggests', res.data)
      })
    },
    setShowSearchResult({ commit }, boolean) {
      commit('setShowSearchResult', boolean)
    },
  },
  mutations: {
    setSuggests(state, payload) {
      state.suggests = payload
    },
    setSearchKeyword(state, payload) {
      state.searchKeyword = payload
    },
    setShowSearchResult(state, boolean) {
      state.showSearchResult = boolean
    },
    setTagName(state, payload) {
      state.tagName = payload
    },
  },
}

export default search
